/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliTeacherDtoApiResponse } from '../../models/amoxcalli-teacher-dto-api-response';
import { AmoxcalliUpdateProfileDto } from '../../models/amoxcalli-update-profile-dto';

export interface ApiAuthProfilePatch$Json$Params {
      body?: AmoxcalliUpdateProfileDto
}

export function apiAuthProfilePatch$Json(http: HttpClient, rootUrl: string, params?: ApiAuthProfilePatch$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliTeacherDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAuthProfilePatch$Json.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliTeacherDtoApiResponse>;
    })
  );
}

apiAuthProfilePatch$Json.PATH = '/api/auth/profile';
